import { Box, Flex, Heading, Accordion, Icon } from "@chakra-ui/react";

import { LuPlus } from "react-icons/lu";

import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { GetStarted } from "../components/GetStarted";

const faqs = [
  {
    id: 1,
    title: "What is social impact investing?",
    content:
      "Social impact investing involves directing capital to projects or organizations that aim to generate measurable social or environmental benefits alongside financial returns.",
  },
  {
    id: 2,
    title:
      "How does social impact investing differ from traditional investing?",
    content:
      "Unlike traditional investing, which primarily focuses on financial returns, social impact investing intentionally seeks to achieve positive societal or environmental outcomes alongside financial gains.",
  },
  {
    id: 3,
    title:
      "What are the potential financial returns of social impact investments?​",
    content:
      "Financial returns can vary depending on the investment, ranging from market-rate returns to below-market returns, depending on the investor's objectives and the project's nature.​",
  },
  {
    id: 4,
    title:
      "How are the social and environmental impacts of investments measured?​",
    content:
      "Impacts are assessed using various metrics and frameworks, such as the Impact Management Project's five dimensions of impact, which evaluate what, who, how much, contribution, and risk.",
  },
  {
    id: 5,
    title: "Who can participate in social impact investing?​",
    content:
      "Both individual and institutional investors can engage in social impact investing, aligning their capital with their values and objectives to support projects that drive positive change.​",
  },
];

export const FAQs = () => {
  return (
    <Box>
      <Header dark={false} />

      <Box
        bg="white"
        py={{ base: "64px", md: "50px" }}
        px={{ base: "16px", md: "25%", "2xl": 0 }}
        maxW={{ base: "100%", "2xl": "1300px" }}
        mx="auto"
        borderTopWidth={"1px"}
        borderColor={"#E8E9EA"}
      >
        <Heading
          fontSize={{ base: "28px", md: "48px" }}
          fontWeight={500}
          color="#101828"
          w={{ base: "100%", md: "60%" }}
          lineHeight={"140%"}
          fontFamily={"DMSans-Medium"}
        >
          Frequently Asked Questions
        </Heading>

        <Box mt={{ base: "32px", md: "64px" }} fontFamily={"Sora-Regular"}>
          <Accordion.Root collapsible size={"lg"}>
            {faqs.map((item) => (
              <Accordion.Item
                key={item.id}
                value={item.id.toString()}
                borderBottomColor={"#EAECF0"}
                py="10px"
              >
                <Accordion.ItemTrigger
                  fontSize={{ base: "16px", md: "19px" }}
                  color={"#101828"}
                  fontWeight={400}
                  justifyContent={"space-between"}
                >
                  {item.title}

                  <Flex
                    align={"center"}
                    justify={"center"}
                    w="24px"
                    h="24px"
                    borderRadius={"12px"}
                    bg="#EBF0F0"
                  >
                    <Icon size={"sm"} color={"#576B6B"}>
                      <LuPlus />
                    </Icon>
                  </Flex>
                </Accordion.ItemTrigger>

                <Accordion.ItemContent color={"#667085"} fontSize={"16px"}>
                  <Accordion.ItemBody>{item.content}</Accordion.ItemBody>
                </Accordion.ItemContent>
              </Accordion.Item>
            ))}
          </Accordion.Root>
        </Box>
      </Box>

      <GetStarted />

      <Footer />
    </Box>
  );
};
